/**
 * Sign-up and sign-in only where the site is served (utils/blockedRegion.js).
 * RegionOneTap is Clerk's GoogleOneTap shown only once the country is known and served;
 * RegionGate puts a plain "not available in your country" in place of a sign-up or
 * sign-in form there.
 */
import { useEffect } from 'react';
import { GoogleOneTap } from '@clerk/clerk-react';
import { Globe } from 'lucide-react';
import { useT } from '../../i18n/LocaleContext';
import { useRegion } from '../../utils/blockedRegion';
import { signupStep } from '../../utils/signupSteps';

export function RegionOneTap(props) {
  const region = useRegion();
  // Counted once a visit (utils/signupSteps.js): offered, whether or not Google then shows its prompt
  useEffect(() => {
    if (region === 'open') signupStep('onetap_offered');
  }, [region]);
  return region === 'open' ? <GoogleOneTap {...props} /> : null;
}

export function NotAvailableHere() {
  const t = useT();
  return (
    <div className="space-y-3 py-6 text-center" data-testid="region-unavailable">
      <Globe className="mx-auto h-8 w-8 text-muted-foreground" aria-hidden="true" />
      <h2 className="text-lg font-semibold text-foreground">{t('auth.unavailableTitle')}</h2>
      <p className="text-sm text-muted-foreground">{t('auth.unavailableBody')}</p>
    </div>
  );
}

export default function RegionGate({ children }) {
  const region = useRegion();
  if (region === 'blocked') return <NotAvailableHere />;
  if (region === 'pending') return <div className="min-h-[24rem]" aria-busy="true" />;
  return children;
}
